import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

// Global Axios Interceptor to forward Identity Headers
axios.interceptors.request.use((config) => {
    const email = localStorage.getItem('email');
    const role = localStorage.getItem('role');
    if (email && role) {
        config.headers['X-User-Email'] = email;
        config.headers['X-User-Role'] = role;
    }
    return config;
});

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const auth = localStorage.getItem('auth');
        const role = localStorage.getItem('role');
        const email = localStorage.getItem('email');

        if (auth === 'true' && role) {
            setUser({ email, role });
        }
        setLoading(false);
    }, []);

    const login = (email, role) => {
        localStorage.setItem('auth', 'true');
        localStorage.setItem('role', role);
        localStorage.setItem('email', email);
        setUser({ email, role });
    };

    const logout = () => {
        localStorage.clear();
        setUser(null);
        window.location.href = '/login';
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
